import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=7528ff7a&scoped=true&"
import script from "./VideoCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./VideoCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=7528ff7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7528ff7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7528ff7a')) {
      api.createRecord('7528ff7a', component.options)
    } else {
      api.reload('7528ff7a', component.options)
    }
    module.hot.accept("./VideoCard.vue?vue&type=template&id=7528ff7a&scoped=true&", function () {
      api.rerender('7528ff7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/VideoCard/VideoCard.vue"
export default component.exports